import React, { useEffect, useState } from "react";

import {
  BsCardChecklist,
  BsArrowRightShort,
  BsClockFill,
} from "react-icons/bs";
import { FaVoteYea } from "react-icons/fa";
import { MdTimerOff } from "react-icons/md";
import { BiCheck, BiExport } from "react-icons/bi";
import { IoIosArrowRoundBack } from "react-icons/io";
import TokenContract from '../getAbis/token.json'
import GovernanceContract from '../getAbis/governance.json'
import StakeContract from '../getAbis/stake.json'
import Menu from "../Home/Menu";
import Footer from "../Home/Footer";
import Web3EthContract from "web3-eth-contract";
import "./custom.css";
import { useWeb3React } from "@web3-react/core";
import { db, storage } from "../firebase/config";
import { addDoc, collection, doc, getDoc, getDocs, setDoc } from "firebase/firestore";
import { getDownloadURL, listAll, ref, uploadBytes } from 'firebase/storage'
import SelectWalletModal from "../walletConnect/modal";
import formatDateAndtime from "../formatDateAndTime";
import swal from "sweetalert";
import { truncateAddress } from "../walletConnect/utils";
import { Tab, Tabs } from "react-bootstrap";
import { AiOutlineStop } from "react-icons/ai";
import { ImCross } from "react-icons/im";
import { BsCheckLg } from "react-icons/bs";
import { claimFund } from "./claim";

const Vote = () => {
  const [isOpen, setIsOpen] = useState(false);
  const onOpen = (e) => {
    setIsOpen(true)
  };
  const onClose = (e) => {
    setIsOpen(false)
  };
  // Wallet Connection
  const { account, active } = useWeb3React();

  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  const [refresh, setRefresh] = useState(true);
  const [noData, setNoData] = useState(true);
  const [owner, setOwner] = useState(0);
  const [balance, setBalance] = useState(0);
  const [proposalData, setProposalData] = useState({});
  const [commentList, setCommentList] = useState([]);
  const [votersList, setVotersList] = useState([]);
  const [proposalId, setProposalId] = useState(0);
  const [tokenStaked, setTokenStake] = useState(0);
  const [fileUploaded, setIsFileUploaded] = useState(false);
  const [fileUploading, setIsFileUploading] = useState(false);
  const [fileLink, setFileLink] = useState('');
  const [filePath, setFilePath] = useState('');
  const [proofLinkDb, setProofLinkDb] = useState('');
  const [fileLinkExist, setFileLinkExists] = useState(false);

  useEffect(() => {
    let propNum = getParameterByName("proposal_id");
    setProposalId(propNum)
    const runFun = async () => {
      // const timestamp = new Date();
      // setCurrentTimeStamp(moment.unix(timestamp) / 1000000)
      const readDocRef = doc(db, "Proposals", String(propNum));
      const docSnap = await getDoc(readDocRef);
      // console.log("doc exists ", docSnap.exists());
      if (docSnap.exists()) {
        setNoData(false);
        getProposalsDetails(propNum, docSnap);
      } else {
        setNoData(true);
      }
    };
    runFun();
  }, [account, active, refresh]);

  const getProposalsDetails = async (proposal_id, docSnap) => {
    const { ethereum } = window;
    Web3EthContract.setProvider(ethereum);
    const contract_stake = new Web3EthContract(StakeContract.abi, StakeContract.STAKE_ADDRESS);
    const governance_contract = new Web3EthContract(GovernanceContract.abi, GovernanceContract.GOVERNANCE_ADDRESS);
    const token_contract = new Web3EthContract(TokenContract.abi, TokenContract.TOKEN_ADDRESS);

    setOwner(await token_contract.methods.owner().call())

    const readDocRefProof = doc(db, "Proof", String(proposal_id));
    const docSnapProof = await getDoc(readDocRefProof);

    if (active) {
      const token_contract = new Web3EthContract(TokenContract.abi, TokenContract.TOKEN_ADDRESS);
      let userInfo = await contract_stake.methods.mapUserInfo(account).call();
      setTokenStake(userInfo.amount)
      setBalance(await token_contract.methods.balanceOf(account).call());
    }
    let proposalDataHere = await governance_contract.methods.proposals(proposal_id).call();
    let proposalStatus = await governance_contract.methods.state(proposal_id).call();
    let supportVotes = Number(proposalDataHere.forVotes / 10 ** 18);
    let oppositeVotes = Number(proposalDataHere.againstVotes / 10 ** 18);
    let unsureVotes = Number(proposalDataHere.abstainVotes / 10 ** 18);
    setProposalData({
      "key": proposal_id,
      "title": docSnap.data().title,
      "description": docSnap.data().description,
      "walletAddress": docSnap.data().walletAddress,
      "fundRequest": proposalDataHere.fundRequest,
      "forVotes": supportVotes,
      "againstVotes": oppositeVotes,
      "abstainVotes": unsureVotes,
      "claimed": proposalDataHere.claimed,
      "voters": proposalDataHere.voters,
      "endDate": formatDateAndtime(new Date(proposalDataHere.endTime * 1000)),
      "startDate": formatDateAndtime(new Date(proposalDataHere.startTime * 1000)),
      "proposer": proposalDataHere.proposer,
      "status": proposalStatus,
      "totalVotes": supportVotes + oppositeVotes + unsureVotes
    })
    if (docSnapProof.exists()) {
      setProofLinkDb(docSnapProof.fileLink)
      setFileLinkExists(true)
    } else {
      setFileLinkExists(false)
    }
    let file = ref(storage, `${proposal_id}/`);

    listAll(file).then((response) => {
      response.items.forEach((item) => {
        getDownloadURL(item).then((url) => {
          // setFileList((prev) => [...prev, url])
          setProposalData({
            "key": proposal_id,
            "title": docSnap.data().title,
            "description": docSnap.data().description,
            "walletAddress": docSnap.data().walletAddress,
            "fundRequest": proposalDataHere.fundRequest,
            "forVotes": supportVotes,
            "againstVotes": oppositeVotes,
            "abstainVotes": unsureVotes,
            "claimed": proposalDataHere.claimed,
            "voters": proposalDataHere.voters,
            "endDate": formatDateAndtime(new Date(proposalDataHere.endTime * 1000)),
            "startDate": formatDateAndtime(new Date(proposalDataHere.startTime * 1000)),
            "proposer": proposalDataHere.proposer,
            "status": proposalStatus,
            "totalVotes": supportVotes + oppositeVotes + unsureVotes,
            "file": url
            // "file": fileList[0]
          })
        })
      })
    })

    // const readDocRefComments = doc(db, "Comments", String(proposal_id));
    // const docSnapComments = await getDoc(readDocRefComments);
    // console.log("docSnapComments  ", docSnapComments.data().forEach((item) => {
    //   console.log("item ", item)
    // }));

    // setCommentList(docSnapComments.data().forEach((item) => {
    //   console.log("item ", item)
    // }))

    // docSnapComments.data().forEach((item) => {
    //   console.log("docSnapComments  ", item);
    // })


    // setProposalData({
    //   "key": proposal_id,
    //   "title": docSnap.data().title,
    //   "description": docSnap.data().description,
    //   "walletAddress": docSnap.data().walletAddress,
    //   "fundRequest": proposalData.fundRequest,
    //   "forVotes": proposalData.forVotes,
    //   "againstVotes": proposalData.againstVotes,
    //   "abstainVotes": proposalData.abstainVotes,
    //   "claimed": proposalData.claimed,
    //   "voters": proposalData.voters,
    //   "endDate": formatDateAndtime(new Date(proposalData.endTime * 1000)),
    //   "startDate": formatDateAndtime(new Date(proposalData.startTime * 1000)),
    //   "proposer": proposalData.proposer,
    //   "status": proposalStatus,
    //   "totalVotes": Number(proposalData.forVotes) + Number(proposalData.againstVotes) + Number(proposalData.abstainVotes),
    //   "file": fileLink
    //   // "file": fileList[0]
    // })
  };

  const voteProposal = async (id) => {
    if (tokenStaked == 0) {
      swal({
        title: "ERROR : TGC Tokens Not Staked",
        text: "You are not eligible to vote",
        icon: "error",
        showCancelButton: false,
        confirmButtonClass: "btn-danger",
        confirmButtonText: "Close",
        closeOnConfirm: false
      });
    } else {
      const { ethereum } = window;
      Web3EthContract.setProvider(ethereum);
      const governance_contract = new Web3EthContract(GovernanceContract.abi, GovernanceContract.GOVERNANCE_ADDRESS);

      // let amount = String(fundRequestAmount * 10 ** 6);
      await governance_contract.methods.castVote(proposalData.key, id).estimateGas({
        from: account
      }).then(async function (gasAmount) {
        let tx = await governance_contract.methods.castVote(proposalData.key, id).send({
          from: account
        }, async function (error, tx) {
          if (error) {
            swal({
              title: "Error Found",
              text: error.message,
              icon: "error",
              showCancelButton: false,
              confirmButtonClass: "btn-danger",
              confirmButtonText: "Close",
              closeOnConfirm: false
            });
          } else {
            swal({
              title: "Voted Successfully",
              text: "Please wait for wallet confirmations.",
              icon: "success",
              showCancelButton: false,
              confirmButtonClass: "btn-danger",
              confirmButtonText: "Close",
              closeOnConfirm: false
            });
          }
        });
        if (tx.status) {
          try {
            const docRef = collection(db, 'Voters') // creating a document reference
            await addDoc(docRef, {
              proposalId,
              walletAddress: account,
              type: id,
            })
          } catch (error) {
            console.log(error)
          }
          setRefresh(!refresh)
        }
      }).catch(function (error) {
        if (error.message.includes('eth_estimateGas')) {
          swal({
            title: "Error Found",
            text: 'Insufficient Funds For Transaction',
            icon: "error",
            showCancelButton: false,

            confirmButtonText: "Close",
            closeOnConfirm: false
          });
        } else if (error.message.includes('voter already voted')) {
          swal({
            title: "Already Voted",
            text: 'You have already voted for this proposal',
            icon: "error",
            showCancelButton: false,
            confirmButtonText: "Close",
            closeOnConfirm: false
          });
        }
        // else if (error.message.includes('proposal not approved for vote')) {
        //   swal({
        //     title: "Proposal Not Approved Yet",
        //     text: 'You can vote after proposal is approved by owner',
        //     icon: "error",
        //     showCancelButton: false,
        //     confirmButtonText: "Close",
        //     closeOnConfirm: false
        //   });
        // }
        else if (error.message.includes('voting is closed')) {
          swal({
            title: "Voting Closed",
            text: 'You cannot vote for a cloased proposal',
            icon: "error",
            showCancelButton: false,
            confirmButtonText: "Close",
            closeOnConfirm: false
          });
        }
        else {
          swal({
            title: "Error Found",
            text: error.message,
            icon: "error",
            showCancelButton: false,
            confirmButtonClass: "btn-danger",
            confirmButtonText: "Close",
            closeOnConfirm: false
          });
        }
      });
    }
  }

  const approveProposal = async () => {
    if (proposalData.status == 2) {
      swal({
        title: "ERROR : Already Succedded",
        text: "Proposal has already been succeedded",
        icon: "error",
        showCancelButton: false,
        confirmButtonClass: "btn-danger",
        confirmButtonText: "Close",
        closeOnConfirm: false
      });
    } else if (proposalData.stauts == 1) {
      swal({
        title: "ERROR : Already Defeated",
        text: "Proposal has been defeated",
        icon: "error",
        showCancelButton: false,
        confirmButtonClass: "btn-danger",
        confirmButtonText: "Close",
        closeOnConfirm: false
      });
    } else {
      const { ethereum } = window;
      Web3EthContract.setProvider(ethereum);
      const governance_contract = new Web3EthContract(GovernanceContract.abi, GovernanceContract.GOVERNANCE_ADDRESS);

      await governance_contract.methods.approved(proposalData.key).estimateGas({
        from: account
      }).then(async function (gasAmount) {
        let tx = await governance_contract.methods.approved(proposalData.key).send({
          from: account
        }, function (error, tx) {
          if (error) {
            swal({
              title: "Error Found",
              text: error.message,
              icon: "error",
              showCancelButton: false,
              confirmButtonClass: "btn-danger",
              confirmButtonText: "Close",
              closeOnConfirm: false
            });
          } else {
            swal({
              title: "Approved Successfully",
              text: "Please wait for wallet confirmations.",
              icon: "success",
              showCancelButton: false,
              confirmButtonClass: "btn-danger",
              confirmButtonText: "Close",
              closeOnConfirm: false
            });
          }
        });
        setRefresh(!refresh)
      }).catch(function (error) {
        if (error.message.includes('eth_estimateGas')) {
          swal({
            title: "Error Found",
            text: 'Insufficient Funds For Transaction',
            icon: "error",
            showCancelButton: false,

            confirmButtonText: "Close",
            closeOnConfirm: false
          });
        } else {
          swal({
            title: "Error Found",
            text: error.message,
            icon: "error",
            showCancelButton: false,
            confirmButtonClass: "btn-danger",
            confirmButtonText: "Close",
            closeOnConfirm: false
          });
        }
      });
    }
  }

  const cancelProposal = async () => {
    if (proposalData.aprroved) {
      swal({
        title: "ERROR : Already Approved",
        text: "Proposal has already been approved",
        icon: "error",
        showCancelButton: false,
        confirmButtonClass: "btn-danger",
        confirmButtonText: "Close",
        closeOnConfirm: false
      });
    } else if (proposalData.canceled) {
      swal({
        title: "ERROR : Already Cancelled",
        text: "Proposal has already been canelled",
        icon: "error",
        showCancelButton: false,
        confirmButtonClass: "btn-danger",
        confirmButtonText: "Close",
        closeOnConfirm: false
      });
    } else {
      const { ethereum } = window;
      Web3EthContract.setProvider(ethereum);
      const governance_contract = new Web3EthContract(GovernanceContract.abi, GovernanceContract.GOVERNANCE_ADDRESS);

      await governance_contract.methods.cancel(proposalData.key).estimateGas({
        from: account
      }).then(async function (gasAmount) {
        let tx = await governance_contract.methods.cancel(proposalData.key).send({
          from: account
        }, function (error, tx) {
          if (error) {
            swal({
              title: "Error Found",
              text: error.message,
              icon: "error",
              showCancelButton: false,
              confirmButtonClass: "btn-danger",
              confirmButtonText: "Close",
              closeOnConfirm: false
            });
          } else {
            swal({
              title: "Cancelled Successfully",
              text: "Please wait for wallet confirmations.",
              icon: "success",
              showCancelButton: false,
              confirmButtonClass: "btn-danger",
              confirmButtonText: "Close",
              closeOnConfirm: false
            });
          }
        });
        setRefresh(!refresh)
      }).catch(function (error) {
        if (error.message.includes('eth_estimateGas')) {
          swal({
            title: "Error Found",
            text: 'Insufficient Funds For Transaction',
            icon: "error",
            showCancelButton: false,

            confirmButtonText: "Close",
            closeOnConfirm: false
          });
        } else {
          swal({
            title: "Error Found",
            text: error.message,
            icon: "error",
            showCancelButton: false,
            confirmButtonClass: "btn-danger",
            confirmButtonText: "Close",
            closeOnConfirm: false
          });
        }
      });
    }
  }

  // const claimFund = async (isClaimed, proposal_id) => {
  //   if (isClaimed) {
  //     // if (proposalData.claimed) {
  //     swal({
  //       title: "ERROR : Already Claimed",
  //       text: "Funds already claimed",
  //       icon: "error",
  //       showCancelButton: false,
  //       confirmButtonClass: "btn-danger",
  //       confirmButtonText: "Close",
  //       closeOnConfirm: false
  //     });
  //   } else {
  //     const { ethereum } = window;
  //     Web3EthContract.setProvider(ethereum);
  //     const governance_contract = new Web3EthContract(GovernanceContract.abi, GovernanceContract.GOVERNANCE_ADDRESS);

  //     await governance_contract.methods.claimFund(proposal_id).estimateGas({
  //       // await governance_contract.methods.claimFund(proposalData.key).estimateGas({
  //       from: account
  //     }).then(async function (gasAmount) {
  //       let tx = await governance_contract.methods.claimFund(proposal_id).send({
  //         // let tx = await governance_contract.methods.claimFund(proposalData.key).send({
  //         from: account
  //       }, function (error, tx) {
  //         if (error) {
  //           swal({
  //             title: "Error Found",
  //             text: error.message,
  //             icon: "error",
  //             showCancelButton: false,
  //             confirmButtonClass: "btn-danger",
  //             confirmButtonText: "Close",
  //             closeOnConfirm: false
  //           });
  //         } else {
  //           swal({
  //             title: "Claimed Successfully",
  //             text: "Please wait for wallet confirmations.",
  //             icon: "success",
  //             showCancelButton: false,
  //             confirmButtonClass: "btn-danger",
  //             confirmButtonText: "Close",
  //             closeOnConfirm: false
  //           });
  //         }
  //       });
  //       setRefresh(!refresh)
  //     }).catch(function (error) {
  //       if (error.message.includes('eth_estimateGas')) {
  //         swal({
  //           title: "Error Found",
  //           text: 'Insufficient Funds For Transaction',
  //           icon: "error",
  //           showCancelButton: false,

  //           confirmButtonText: "Close",
  //           closeOnConfirm: false
  //         });
  //       } else {
  //         swal({
  //           title: "Error Found",
  //           text: error.message,
  //           icon: "error",
  //           showCancelButton: false,
  //           confirmButtonClass: "btn-danger",
  //           confirmButtonText: "Close",
  //           closeOnConfirm: false
  //         });
  //       }
  //     });
  //   }
  // }
  const [userName, setUserName] = useState('');
  const [commentBody, setCommentBody] = useState('');

  const addComment = async () => {
    if (commentBody == '') {
      swal({
        title: "Error Found",
        text: "Comment cannot be empty",
        icon: "error",
        showCancelButton: false,
        confirmButtonClass: "btn-danger",
        confirmButtonText: "Close",
        closeOnConfirm: false
      });
    }
    // else if (userName == '') {
    //   swal({
    //     title: "Error Found",
    //     text: "Please enter username",
    //     icon: "error",
    //     showCancelButton: false,
    //     confirmButtonClass: "btn-danger",
    //     confirmButtonText: "Close",
    //     closeOnConfirm: false
    //   });
    // } 
    else {
      try {
        const docRef = collection(db, 'Comments') // creating a document reference
        await addDoc(docRef, {
          key: proposalId,
          // userName,
          walletAddress: account,
          commentBody,
        })
        setRefresh(!refresh)
      } catch (error) {
        console.log(error)
      }
    }
  }

  useEffect(() => {
    const docRefComments = collection(db, 'Comments')
    const getCommentList = async () => {
      const data = await getDocs(docRefComments)
      setCommentList(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
    }
    getCommentList()
  }, [commentList, refresh])

  useEffect(() => {
    const docRefVoters = collection(db, 'Voters')
    const getVotersList = async () => {
      const data = await getDocs(docRefVoters)
      setVotersList(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
    }
    getVotersList()
  }, [votersList, refresh])

  const submitProof = async () => {
    setIsFileUploading(true)
    if (fileLink == '' || filePath == null) {
      swal({
        title: "ERROR : Invalid Proof",
        text: "Please either upload an image or provide link",
        icon: "error",
        showCancelButton: false,
        confirmButtonClass: "btn-danger",
        confirmButtonText: "Close",
        closeOnConfirm: false
      });
    } else {
      if (fileLink != '') {
        try {
          const docRef = doc(db, 'Proof', `${proposalId}`)
          await setDoc(docRef, {
            fileLink
          })
        } catch (error) {
          console.error("ERROR : Firebase ==>", error)
          swal({
            title: "ERROR : Firebase",
            text: "Something went wrong, please contact the owner",
            icon: "error",
            showCancelButton: false,
            confirmButtonClass: "btn-danger",
            confirmButtonText: "Close",
            closeOnConfirm: false
          });
        }
      }
      if (filePath.name.includes('png') || filePath.name.includes('jpeg') || filePath.name.includes('jpg')) {
        const fileRef = ref(storage, `${proposalId}/${filePath.name}`);
        uploadBytes(fileRef, filePath).then(async () => {
          setIsFileUploaded(true)
          setIsFileUploading(false)

        }).then(() => {
          swal({
            title: "File Uploded Successfully",
            // text: "",
            icon: "success",
            showCancelButton: false,
            confirmButtonClass: "btn-danger",
            confirmButtonText: "Close",
            closeOnConfirm: false
          });
          setRefresh(!refresh)
        }).catch((error) => {
          console.log("error file upload ", error)
          swal({
            title: "ERROR : File Could NOT be Uploaded",
            text: "Something went wrong, please contact the owner",
            icon: "error",
            showCancelButton: false,
            confirmButtonClass: "btn-danger",
            confirmButtonText: "Close",
            closeOnConfirm: false
          });
        });
      }
      else if (filePath.name != null) {
        swal({
          title: "ERROR : File Format",
          text: "Only image files accepted (png,jpg,jpeg)",
          icon: "error",
          showCancelButton: false,
          confirmButtonClass: "btn-danger",
          confirmButtonText: "Close",
          closeOnConfirm: false
        });
      }
    }



  }

  return (
    <>
      <Menu />
      <section className="SnVote proPosal DaoMainSection DAOSlider sliderSection">
        <img src="./images/glowlogo.png" className="img-responsive glowlogo" />
        <div className="container">
          {noData ? (
            <div className="row">
              <div className="col-sm-12">
                <h4 className="text-center text-warning">
                  Proposal Not Found
                </h4>
                <p className="backLink text-center">
                  <a href="/dao">
                    <IoIosArrowRoundBack />
                    Back to DAO Overview
                  </a>
                </p>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-sm-8">
                <p className="backLink">
                  <a href="/dao">
                    <IoIosArrowRoundBack />
                    Back to DAO Overview
                  </a>
                </p>
                {/* <button className="orenge_btn mb-3" >
                  <FaVoteYea /> Vote Now
                </button> */}
                <h4 className="text-left ">
                  <p className="text-success text-uppercase">
                    {proposalData.approved ?
                      "NOTE : This Proposal is already Approved"
                      :
                      <></>
                    }
                  </p>
                  <p className="text-danger text-uppercase">
                    {proposalData.status == 1 ?
                      "NOTE : This Proposal has been defeated"
                      :
                      <></>
                    }
                  </p>
                  {/* Improvement Proposal For Perpetual Trading */}
                  {proposalData.title}
                </h4>
                <p>
                  {proposalData.description}
                  {/* Not sure if this is doable, but here are my ideas I used the
                  perpetual for a while and I'm unsatisfied with it (compare to
                  other derivative DEX) */}
                </p>
                <br />

                {account == owner ?
                  <>
                    <a href={proofLinkDb}>
                      <p className="text-success fw-bolder text-decoration-underline">Proof of Completion Link</p>
                    </a>
                    <a href={proposalData.file}>
                      <img src={proposalData.file} width={100} alt="" />
                    </a>
                  </>
                  :
                  <></>
                }

                {/* <h5>Problem 1 - High Fee</h5>
                <p>
                  It charges a high fee on the taker which is 0.07%, the average
                  taker fee in the industry (include both CEX and DEX) is
                  roughlyaround 0.05% ~ 0.06% This alone isn't a big deal as
                  long as the maker fee maintain at 0.02% which is consistent
                  with theindustry. However, maker fee will not be the solution
                  to problem 1 as long as problem 2 exists
                </p> */}

                <div className="portal_box single_cart">
                  <h5>Actions</h5>
                  <div className="radioss">

                    {/* {account == owner ?
                      <>
                        <p className="text-success mb-1">You can either approve or reject this prosal</p>
                        <div className="d-flex">
                          <div className="sn_radio bg-success mx-1 w-25" onClick={() => approveProposal()}>
                            <label className="label" for="Vote">
                              Approve
                            </label>
                          </div>
                          <div className="sn_radio bg-danger  mx-1 w-25" onClick={() => cancelProposal()}>
                            <label className="label" for="Vote">
                              Reject
                            </label>
                          </div>
                        </div>
                      </>
                      :
                      <></>
                    } */}


                    {active ?
                      <>
                        {proposalData.status != 0 ?

                          <p className="text-danger">No Longer availablefor voting</p>
                          :
                          <>
                            <div className="sn_radio" onClick={() => voteProposal(1)}>
                              {/* <input type="checkbox" id="Vote" value="Vote" /> */}
                              <label className="label" for="Vote">
                                Absolutely Agree
                              </label>
                            </div>
                            <div className="sn_radio" onClick={() => voteProposal(0)}>
                              {/* <input type="checkbox" id="Close" value="Close" /> */}
                              <label className="label" for="Close">
                                Disagree
                              </label>
                            </div>
                            <div className="sn_radio" onClick={() => voteProposal(2)}>
                              {/* <input type="checkbox" id="Soon" value="Soon" /> */}
                              <label className="label" for="Soon">
                                Not Sure
                              </label>
                            </div>

                            {tokenStaked > 0 ?
                              <p className="text-success">Click above to vote</p>
                              :
                              <p className="text-danger">Stake TGC tokens to vote</p>
                            }

                            {/* {account == proposalData.proposer ?
                              <>
                                <div className="d-flex">
                                  <div className="sn_radio bg-danger  mr-1 mt-2 w-25" onClick={() => cancelProposal()}>
                                    <label className="label" for="Vote">
                                      Cancel
                                    </label>
                                  </div>
                                </div>
                              </>
                              :
                              <></>
                            } */}

                            {proposalData.status == 2 && account == proposalData.proposer ?
                              <>
                                <br />
                                <h3>You can claim your funds now and submit proof of completion</h3>
                                <div className="d-flex">
                                  {proposalData.claimed ?
                                    <div className="sn_radio bg-success  mr-1 mt-2 w-25">
                                      {/* <input type="checkbox" id="Vote" value="Vote" /> */}
                                      <label className="label">
                                        Already Claimed
                                      </label>
                                    </div>
                                    :
                                    <div className="sn_radio bg-success  mr-1 mt-2 w-25" onClick={() => claimFund(account, proposalData.claimed, proposalData.key)}>
                                      {/* <input type="checkbox" id="Vote" value="Vote" /> */}
                                      <label className="label" for="Vote">
                                        Claim
                                      </label>
                                    </div>
                                  }
                                </div>
                                {fileLinkExist ?
                                  <></>
                                  :
                                  <>
                                    <div className="form-group">
                                      <label>Proof Of Completion (image)</label>
                                      <input type="file" name="" className="form-control" onChange={(e) => { setFilePath(e.target.files[0]) }} />
                                      {/* <br />
                                  OR
                                <br /> */}
                                      OR <br />
                                      <label>Proof Of Completion (Link)</label>
                                      <input type="text" name="" className="form-control" onChange={(e) => { setFileLink(e.target.value) }} />
                                    </div>
                                    <button className="orenge_btn" onClick={submitProof}>Submit Proof</button>
                                  </>
                                }
                              </>
                              :
                              <></>
                            }

                          </> // approved or cancelled
                        }
                      </> // Active
                      :
                      <button className="orenge_btn" onClick={onOpen}>Connect wallet</button>
                    }
                  </div>
                </div>

                <div className="portal_box single_cart">
                  <h5>Comments</h5>
                  <div className="list" style={{ height: '300px', overflowY: 'auto' }}>
                    <div className="si_list">
                      <div className="row w-100">
                        {/* <div className="row">
                            <div className="col-sm-12">
                              <p className="t_orenge">
                                {truncateAddress(commentList.account)}
                              </p>
                              <p>
                                {commentList.comment}
                              </p>
                            </div>
                          </div> */}

                        {commentList.map((item, index) => {
                          console.log("items here ", item)
                          if (item.key == proposalId) {
                            return (

                              <div className="col-sm-12 ">
                                <div className="row" key={index}>
                                  <div className="col-sm-12">
                                    <p className="text-capitalize pb-1">
                                      <img
                                        style={{
                                          width: '30px', borderRadius: '100%', margin: ' 0 5px'
                                        }}
                                        src="https://e7.pngegg.com/pngimages/178/595/png-clipart-user-profile-computer-icons-login-user-avatars-monochrome-black-thumbnail.png" alt="" />
                                      {/* {item.userName} */}
                                      <a href={`https://etherscan.io/address/${item.walletAddress}`} className="m-1">
                                        <span className="t_orenge">
                                          {truncateAddress(item.walletAddress)} <BiExport />
                                        </span>
                                      </a>
                                    </p>

                                  </div>
                                  <div className="col-sm-12">
                                    <p className="text-capitalize pt-1" style={{ fontSize: '16px' }}>{item.commentBody} </p>
                                  </div>
                                  <div className="col-sm-4">
                                    {/* <p className="t_orenge">
                                      117,246.688{" "}
                                      <span className="t_orenge">
                                        <BiExport />
                                      </span>{" "}
                                    </p> */}
                                  </div>
                                </div>
                                <hr />
                              </div>
                            )
                          }
                        })
                        }
                      </div>
                    </div>
                  </div>
                  <div className="mt-3">
                    <h5>Add Comment</h5>
                    {/* <div class="form-group"><label>Username</label><input type="text" name="" class="form-control" onChange={(e) => setUserName(e.target.value)} required /></div> */}
                    <div class="form-group">
                      <label>Comment</label>
                      <textarea type="text" rows="8" name="" class="form-control" onChange={(e) => setCommentBody(e.target.value)} required></textarea>
                      <br />
                      <button class="orenge_btn" onClick={addComment} >Comment</button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-sm-4">
                <div className="portal_box single_cart">
                  <h5>Details</h5>

                  <div className="snaps">
                    {/* <label>
                      Identifier{" "}
                      <a href="#">
                        <span>
                          23837904 <BiExport />
                        </span>
                      </a>
                    </label> */}
                    <label>
                      Creator{" "}
                      <a href="#">
                        <span>
                          <a href={`https://etherscan.io/address/${proposalData.walletAddress}`}></a>{truncateAddress(proposalData.walletAddress)} <BiExport />
                        </span>
                      </a>
                    </label>
                    {/* <label>
                      Snapshot{" "}
                      <a href="#">
                        <span>
                          23837904 <BiExport />
                        </span>
                      </a>
                    </label> */}
                    <div className="proPosal ">
                      <div className="special_form">
                        <p>Start Date: {proposalData.startDate}</p>
                        <p>End Date: {proposalData.endDate}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="portal_box single_cart">
                  <h5>Current Results</h5>
                  <div className="sn_range snaps">
                    <label>Absolutely Agree</label>
                    <div className="widthFull">
                      <div
                        className="percentage"
                        style={{ width: `${(proposalData.forVotes * 100 / proposalData.totalVotes).toFixed(2)}%` }}
                      ></div>
                    </div>
                    <p>
                      <span>{parseFloat(proposalData.forVotes).toFixed(2)} Votes</span>
                      <span>{parseFloat(proposalData.totalVotes).toFixed(2)} Votes</span>
                      {proposalData.totalVotes == 0 ?
                        <span className="text_right">0%</span>
                        :
                        <span className="text_right">{(proposalData.forVotes * 100 / proposalData.totalVotes).toFixed(2)}%</span>
                      }
                    </p>
                  </div>
                  <div className="sn_range snaps">
                    <label>Absolutely Diagree</label>
                    <div className="widthFull">
                      <div
                        className="percentage"
                        style={{ width: `${(proposalData.againstVotes * 100 / proposalData.totalVotes).toFixed(2)}%` }}
                      ></div>
                    </div>
                    <p>
                      <span>{parseFloat(proposalData.againstVotes).toFixed(2)} Votes</span>
                      {proposalData.totalVotes == 0 ?
                        <span className="text_right">0%</span>
                        :
                        <span className="text_right">{(proposalData.againstVotes * 100 / proposalData.totalVotes).toFixed(2)}%</span>
                      }
                    </p>
                  </div>
                  <div className="sn_range snaps">
                    <label>Not Sure / Abstain Votes</label>
                    <div className="widthFull">
                      <div
                        className="percentage"
                        style={{ width: `${(proposalData.abstainVotes * 100 / proposalData.totalVotes).toFixed(2)}%` }}
                      ></div>
                    </div>
                    <p>
                      <span>{parseFloat(proposalData.abstainVotes).toFixed(2)} Votes</span>
                      {proposalData.totalVotes == 0 ?
                        <span className="text_right">0%</span>
                        :
                        <span className="text_right">{(proposalData.abstainVotes * 100 / proposalData.totalVotes).toFixed(2)}%</span>
                      }
                    </p>
                  </div>
                </div>

                <div className="portal_box single_cart p-2">
                  <Tabs defaultActiveKey="first">
                    <Tab eventKey="first" title="All">
                      <div className="list">
                        <div className="si_list">
                          <br />
                          {votersList.map((item, index) => {
                            if (item.proposalId == proposalId) {
                              return (
                                <div className="col-sm-12 ">
                                  <div className="row" key={index}>
                                    <div className="col-sm-6">
                                      <p>
                                        <a href={`https://goerli.etherscan.io/address/${item.walletAddress}`} className="m-1">
                                          <span className="text-white">
                                            {truncateAddress(item.walletAddress)} <BiExport />
                                          </span>
                                        </a>
                                      </p>
                                    </div>
                                    <div className="col-sm-6">
                                      {item.type == 1 ?
                                        <p className="text-success">Absolutely Agree <BsCheckLg /></p>
                                        :
                                        <>
                                          {item.type == 0 ?
                                            <p className="text-danger">Absolutely Diagree <ImCross /></p>
                                            :
                                            <p className="text-warning">Not Sure <AiOutlineStop /></p>
                                          }
                                        </>
                                      }
                                    </div>
                                  </div>
                                  <hr />
                                </div>
                              )
                            }
                          })
                          }
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="second" title="Support Voters">
                      <div className="list">
                        <div className="si_list">
                          <br />
                          {votersList.map((item, index) => {
                            if (item.proposalId == proposalId && item.type == 1) {
                              return (
                                <div className="col-sm-12 ">
                                  <div className="row" key={index}>
                                    <div className="col-sm-6">
                                      <p>
                                        <a href={`https://goerli.etherscan.io/address/${item.walletAddress}`} className="m-1">
                                          <span className="text-white">
                                            {truncateAddress(item.walletAddress)} <BiExport />
                                          </span>
                                        </a>
                                      </p>
                                    </div>
                                    <div className="col-sm-6">
                                      <p className="text-success">Absolutely Agree <BsCheckLg /></p>
                                    </div>
                                  </div>
                                  <hr />
                                </div>
                              )
                            }
                          })
                          }
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="third" title="Against Voters">
                      <div className="list">
                        <div className="si_list">
                          <br />
                          {votersList.map((item, index) => {
                            if (item.proposalId == proposalId && item.type == 0) {
                              return (
                                <div className="col-sm-12 ">
                                  <div className="row" key={index}>
                                    <div className="col-sm-6">
                                      <p>
                                        <a href={`https://goerli.etherscan.io/address/${item.walletAddress}`} className="m-1">
                                          <span className="text-white">
                                            {truncateAddress(item.walletAddress)} <BiExport />
                                          </span>
                                        </a>
                                      </p>
                                    </div>
                                    <div className="col-sm-6">
                                      <p className="text-danger">Absolutely Agree <ImCross /></p>
                                    </div>
                                  </div>
                                  <hr />
                                </div>
                              )
                            }
                          })
                          }
                        </div>
                      </div>
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      <SelectWalletModal isOpen={isOpen} closeModal={onClose} />
      <Footer />
    </>
  );
};
export default Vote;
